import envConfig from '../env-config';
import { log } from '../log';
import * as consts from './gateway-consts';
export const APP_JSON = 'application/json';

const REQUIRED_HEADERS = {
  apikey: 'l7b880a72ec87c44dc93c79f1e42f6473d',
  'Content-Type': APP_JSON,
};

export interface IGatewayError {
  errors: {
    id: string;
    href: string;
    status: string;
    code: string;
    title: string;
    detail: string;
  }[];
}

export interface ITryGatewayResult<T, E = unknown> {
  success: boolean;
  requiresStepUpAuth: boolean;
  error?: E;
  result?: T;
}

export const callApi = async (
  url: string,
  method: string,
  headers: { [name: string]: any } = {},
  body: any = undefined,
  queryParams: { [name: string]: any } = {},
): Promise<ITryGatewayResult<Response>> => {
  const result: ITryGatewayResult<Response> = {
    success: false,
    requiresStepUpAuth: false,
  };

  try {
    const finalHeaders = {
      ...REQUIRED_HEADERS,
      ...headers,
    };

    const r = await window.fetch(
      `${envConfig.gatewayApi}${url}${envConfig.envSuffix}${compileQueryParams(
        queryParams,
      )}`,
      {
        method,
        credentials: 'include',
        headers: finalHeaders,
        body: body ? JSON.stringify(body) : undefined,
        cache: 'no-store',
      },
    );

    result.result = r;
    result.success = r.ok;
    result.requiresStepUpAuth = await requiresStepUpAuth(r);
    return result;
  } catch (e) {
    result.error = e;
    log.error(`callApi error: ${e}`);
    throw e;
  }
};

function compileQueryParams(queryParams: { [name: string]: any }) {
  return Object.keys(queryParams).reduce((acc, key, index) => {
    return `${acc}${index === 0 ? '?' : '&'}${key}=${encodeURIComponent(
      queryParams[key],
    )}`;
  }, '');
}

export const requiresStepUpAuth = async (
  response: Response,
): Promise<boolean> => {
  if (response.status === 403) {
    try {
      const body: IGatewayError = await response.json();
      if (body?.errors?.[0]?.detail === 'Step-up auth invalid') {
        return true;
      }
    } catch (e) {
      log.error(`Error parsing response body: ${e}`);
    }
  }
  return false;
};

export const postPaymentPreferences = async (body: any) =>
  callApi(
    `${consts.baseApis.totalLeaveEmployees}${consts.endpoints.paymentPreferences}`,
    'POST',
    {},
    body,
  );
